import PropTypes from "prop-types";
import React from "react";

import { PropTypeShapes } from "../../types";
const CalendarPickerRow = props => {
  return (
    <div
      onClick={props.onClick}
      className={`calendarPickerRow${props.selected ? " selected" : ""}${props.isSelectable ? " selectable" : ""}`}
    >
      {props.title ? <div className="title">{props.title}</div> : null}
      <div className="rowContent">{props.children}</div>
    </div>
  );
};

CalendarPickerRow.propTypes = {
  title: PropTypes.string,
  children: PropTypeShapes.elementOrArray,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  isSelectable: PropTypes.bool
};

export default CalendarPickerRow;
